import { FGPLnwLaunchData } from '@/features/providers/lnw/types';
import { buildUrl } from '@/utils/build-url';

const lnwUrlBuilderFgp = (
  data: FGPLnwLaunchData,
  isNetPositionEnabled?: string | boolean,
): string => {
  const {
    host,
    accountid,
    device,
    nogscurrency,
    nogsgameid,
    nogslang,
    nogsmode,
    nogsoperatorid,
    sessionid,
    winloss,
    url,
  } = data.launchDetails;

  if (url) {
    const parsedUrl = new URL(url);
    const winlossParam = parsedUrl.searchParams.get('winloss');
    if (winlossParam && !isNetPositionEnabled) {
      parsedUrl.searchParams.delete('winloss');
    }
    return parsedUrl.href;
  }

  const params = {
    accountid,
    device,
    nogscurrency,
    nogsgameid,
    nogslang,
    nogsmode,
    nogsoperatorid,
    sessionid,
    lobbyurl: data.lobbyUrl,
    ...(winloss && isNetPositionEnabled && { winloss }),
  };

  return buildUrl(host!, params);
};

export const buildLnwUrl = (
  input: FGPLnwLaunchData,
  isNetPositionEnabled?: string | boolean,
): string => lnwUrlBuilderFgp(input, isNetPositionEnabled);
